<template>
  <div>
    <div class="p25 bgfff rightbox">
      <h2 class="title">兑换规则</h2>
      <ul>
        <li>
          <h3>凡注册用户可以通过积分兑换积分商城中的商品：</h3>
          <p @click="getcreditrule">1、如何获得积分</p>
        </li>
        <li>
          <p>2、保障兑换的顺利进行,请您确保已登录账号</p>
        </li>
        <li>
          <p>3、兑换成功后，工作人员会在24小时内进行处理；</p>
        </li>
        <li>
          <p>4、如7天内未收到兑换商品,会有相关工作人员为您处理。</p>
        </li>
      </ul>
    </div>
    <el-dialog
      custom-class="creditruledialog"
      title="积分规则"
      :visible.sync="creditruleflag"
      width="40%"
      center>
      <el-table
        :data="creditruletableData"
        height="288"
        style="width: 100%">
        <el-table-column
          width="50"
          prop="customid"
          label="序号">
        </el-table-column>
        <el-table-column
          prop="ruleName"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="credit"
          label="积分">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
    <!--    <el-button @click="creditruleflag = false">取 消</el-button>-->
        <el-button type="primary" @click="creditruleflag = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getuserpointcreditRule } from '@/api/user/index'
export default {
  name: 'creditrule',
  data () {
    return {
      creditruleParam: {
        pageNum: 1,
        limit: 12
      },
      creditruleflag: false,
      creditruletableData: []
    }
  },
  methods: {
    /* 获取积分规则 */
    getcreditrule () {
      getuserpointcreditRule(this.$cookie.get('culturalCloud_fid'), this.creditruleParam).then(res => {
        console.log(res)
        if (res.data.status === 0) {
          res.data.data.forEach((item, index) => {
            item.customid = index + 1
          })
          this.creditruletableData = res.data.data
          this.creditruleflag = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rightbox{
  h2.title{
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 5px 0;
  }
  ul{
    li{
      border-bottom: 1px dashed rgb(204, 204, 204);
      padding: 10px 0;
      cursor: pointer;
      h3{
        color: #4584a7;
        font-size: 14px;
        margin: 0 0 5px 0;
      }
      &:last-child{
        border-bottom: none;
      }
      &:nth-child(1):hover{
        p{
          color: #4584a7;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pointsmall/creditrule.vue